// src/pages/auth/VerifyOTPReset.js
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Input, Button } from "../../components/common";
import "./VerifyOTPReset.css"; // Reuse same CSS as VerifyOTP.js
import { PhoneAuthProvider, signInWithCredential } from "firebase/auth";
import { auth } from "../../firebase";

export default function VerifyOTPReset() {
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [resendTimer, setResendTimer] = useState(0);
  const [verificationId, setVerificationId] = useState("");

  useEffect(() => {
    if (location.state?.phoneNumber) {
      setPhoneNumber(location.state.phoneNumber);
    }
    const vid = sessionStorage.getItem("firebase_verificationId");
    if (vid) setVerificationId(vid);
  }, [location]);

  // Timer for resend OTP button
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer((t) => t - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);

  const handleOtpChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 6) {
      setOtp(value);
      setError("");
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError("");

    if (!otp.trim() || otp.length < 6) {
      setError("Please enter the 6-digit OTP");
      return;
    }

    try {
      if (!verificationId) {
        setError("Verification session missing. Please request OTP again.");
        return;
      }

      // 1. Verify OTP with Firebase
      const credential = PhoneAuthProvider.credential(verificationId, otp);
      const userCred = await signInWithCredential(auth, credential);

      console.log("🔥 OTP verified successfully with Firebase");

      // 2. Store verification ID and phone for next page
      sessionStorage.setItem("resetPhoneVerified", "true");
      sessionStorage.setItem("resetPhoneNumber", phoneNumber);

      // 3. Navigate to reset password page
      navigate("/reset-password", { state: { phoneNumber } });
    } catch (err) {
      console.error("OTP verify error:", err);
      setError("Invalid OTP. Please try again.");
    }
  };

  const handleResendOtp = async () => {
    setError("");
    setOtp("");
    setResendTimer(30);
    // Best UX: go back to forgot-password and click "Send OTP" to re-run recaptcha + send
    setError("Please go back to the forgot password page and click Send OTP to resend.");
  };

  const handleBackToForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <div className="verify-otp-root">
      <div className="verify-otp-top">
        <div className="verify-otp-icon">
          <i className="fas fa-lock"></i>
        </div>
        <p className="verify-otp-message">
          OTP successfully sent to<br />
          {phoneNumber}
        </p>
      </div>

      <div className="verify-otp-bottom">
        <form className="verify-otp-form" onSubmit={handleVerify}>
          <h2 className="verify-otp-heading">Verify OTP</h2>

          {error && <p className="verify-otp-error">{error}</p>}

          <Input
            type="text"
            placeholder="Enter OTP"
            className="verify-otp-input"
            value={otp}
            onChange={handleOtpChange}
            maxLength={6}
            required
          />

          <Button
            type="submit"
            className="verify-otp-button"
            style={{
              background: "#A4E376",
              color: "#000000",
              fontWeight: 700,
              fontSize: "1.05rem",
              padding: "0.9rem 2rem",
              borderRadius: "1.8rem",
              border: "none",
              marginTop: "1.5rem",
              minHeight: "2.8rem",
              cursor: "pointer",
            }}
          >
            Verify
          </Button>

          <div className="verify-otp-footer">
            <p className="verify-otp-resend">
              Didn't receive OTP?
              <Button
                type="button"
                className="verify-otp-back-link"
                disabled={resendTimer > 0}
                onClick={handleResendOtp}
                style={{
                  background: "none",
                  border: "none",
                  color: "#89D957",
                  cursor: resendTimer > 0 ? "not-allowed" : "pointer",
                  marginLeft: "0.5rem",
                  padding: 0,
                  fontSize: "1rem",
                  textDecoration: "underline",
                  opacity: resendTimer > 0 ? 0.5 : 1,
                }}
              >
                {resendTimer > 0 ? `Resend in ${resendTimer}s` : "Resend OTP"}
              </Button>
            </p>
            <a
              href="#"
              className="verify-otp-back-link"
              onClick={handleBackToForgotPassword}
              style={{ marginTop: "1rem", display: "block", textAlign: "center" }}
            >
              Back to Forgot Password
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}
